module.exports = __webpack_public_path__ + "img/success-check.svg";